<section class="disclaimer-banner" tabindex="0" role="button" aria-label="Disclaimer" (click)="onBannerClick()" (keydown.enter)="onBannerClick()">
  <div class="disclaimer-header">
    <span class="disclaimer-icon" aria-hidden="true">
      <svg width="36" height="36" fill="none" viewBox="0 0 36 36"><circle cx="18" cy="18" r="18" fill="#FFD600"/><path d="M18 10v8" stroke="#222" stroke-width="2.5" stroke-linecap="round"/><circle cx="18" cy="25" r="1.5" fill="#222"/></svg>
    </span>
    <span class="disclaimer-title">Disclaimer</span>
  </div>
  <div class="disclaimer-main">
    <div class="disclaimer-highlight">Wichtiger Hinweis zur Anlageberatung</div>
    <div class="disclaimer-text"><span class="disclaimer-bold">Wichtig:</span> Die Informationen auf dieser Website dienen ausschließlich Informationszwecken und stellen keine Anlageberatung dar. Sie ersetzen in keinem Fall die professionelle Beratung durch einen Anlageberater oder Finanzdienstleister.</div>
    <div class="disclaimer-grid">
      <div class="disclaimer-card">
        <span class="disclaimer-card-title">Keine Anlageempfehlungen:</span>
        <span>Die auf dieser Website bereitgestellten Informationen und Meinungen dürfen nicht als Aufforderung oder Empfehlung zum Kauf oder Verkauf von Wertpapieren oder anderen Finanzprodukten verstanden werden.</span>
      </div>
      <div class="disclaimer-card">
        <span class="disclaimer-card-title">Keine Haftung:</span>
        <span>Die Betreiber dieser Website übernehmen keine Haftung für Verluste oder Schäden, die aus der Nutzung der hier bereitgestellten Informationen entstehen.</span>
      </div>
      <div class="disclaimer-card">
        <span class="disclaimer-card-title">Anlageentscheidungen:</span>
        <span>Anlageentscheidungen sollten stets auf Grundlage Ihrer individuellen Situation und Risikotoleranz getroffen werden. Wir empfehlen Ihnen, vor jeder Anlageentscheidung einen qualifizierten Anlageberater zu konsultieren.</span>
      </div>
      <div class="disclaimer-card">
        <span class="disclaimer-card-title">Risiken:</span>
        <span>Investitionen in Wertpapiere und andere Finanzprodukte sind immer mit Risiken verbunden. Der Wert einer Anlage kann schwanken und es besteht die Möglichkeit, dass Sie Geld verlieren.</span>
      </div>
    </div>
  </div>
  <div class="disclaimer-footer">
    Durch die weitere Nutzung dieser Website stimmen Sie den oben genannten Bedingungen zu.
  </div>
</section> 